import { render, staticRenderFns } from "./sidebarSpotWallet.vue?vue&type=template&id=e4950096&"
import script from "./sidebarSpotWallet.vue?vue&type=script&lang=js&"
export * from "./sidebarSpotWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports